import React from 'react';
import {DATE_FORMAT_URL} from '../../../../../../data/constants/datetime';
import {eventMomentFactory} from '../../../../../../data/misc/eventMomentFactory';
import Link from '../../../../../elements/Link';
import RoundImage from '../../../../../elements/RoundImage';
import stylesheet from './SpeakerDetails.module.scss';

const SpeakerDetails = props => {
    const {className, event, speaker, session} = props;

    return (
        <Link
            className={[stylesheet.SpeakerDetails, 'speaker ', className].join(' ')}
            href={['/events', event.id, 'schedule', eventMomentFactory(event, session.start_local).format(DATE_FORMAT_URL), session.id].join('/')}>
            <RoundImage className="avatar" src={speaker.photo_url} altSrc="img/no_avatar.png" size={80} />
            <p className={stylesheet.details}>
                <b title={speaker.name}>{speaker.name}</b>
            </p>
            {speaker.company ? <p title={speaker.company}>{speaker.company}</p> : null}
            {speaker.company ? <p title={speaker.position}>{speaker.position}</p> : null}
        </Link>
    );
};

export default SpeakerDetails;
